import './App.css';
import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Layout from './components/Layout';
import { createBrowserHistory } from 'history';
import { inject, observer } from 'mobx-react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import 'font-awesome/css/font-awesome.min.css';

const history = createBrowserHistory();

@inject('store')
@observer
class App extends Component {
    componentDidMount() {
        ConfigProvider.config({
            theme: {
                primaryColor: '#3B70FF',
                primaryColorHover: '#6392FF',
                primaryColorActive: '#2750D9',
                primary1: '#F0F6FF',
                primary2: '#DEEBFF',
                primary3: '#B5D0FF',
                primary4: '#8CB2FF',
                primary5: '#6392FF',
                primary6: '#3B70FF',
                primary7: '#2750D9'
            }
        });
    }

    render() {
        return (
            <div className="App">
                <BrowserRouter history={history}>
                    <ConfigProvider locale={zhCN}>
                        <Layout />
                    </ConfigProvider>
                </BrowserRouter>
            </div>
        );
    }
}

export default App;
